import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import {
  EIntegrationStatus,
  TCustomField,
} from 'src/app/project/modules/custom-fields/custom-fields.model';
import { CustomFieldsService } from 'src/app/project/modules/custom-fields/custom-fields.service';
import { EFormulaPieceType, TFormulaPiece } from '../utils/formula-input.type';
import { FORMULA_MAX_CUSTOM_FIELDS, FORMULA_MAX_NESTING_LEVEL } from '../utils/formula.consts';

@Component({
    selector: 'pp-formula-builder-custom-fields',
    templateUrl: './formula-builder-custom-fields.component.html',
    styleUrl: './formula-builder-custom-fields.component.scss',
    standalone: false
})
export class FormulaBuilderCustomFieldsComponent implements OnInit, DoCheck {
  @Input() ppWorkspaceId: string;
  @Input() ppFormula: TFormulaPiece[] = [];
  @Input() ppFieldId: string;
  @Output() ppSelectOperator = new EventEmitter<TFormulaPiece>();

  customFields: TFormulaPiece[] = [];
  disabled: boolean = false;
  FORMULA_MAX_NESTING_LEVEL = FORMULA_MAX_NESTING_LEVEL;
  private _previousListLength: number = 0;

  constructor(private customFieldsService: CustomFieldsService) {}

  ngDoCheck(): void {
    if (this.ppFormula && this.ppFormula.length !== this._previousListLength) {
      this._previousListLength = this.ppFormula.length;
      this.checkFormulaCustomFieldsDisabled();
    }
  }

  ngOnInit(): void {
    const customFields = this.customFieldsService.getWorkspaceCustomFields(this.ppWorkspaceId);

    this.customFields = Object.values(customFields)
      .filter((customField) => {
        const isHidden =
          customField.volyIntegrationActive !== EIntegrationStatus.OFF && !customField.display;

        return (
          customField.id !== this.ppFieldId &&
          !isHidden &&
          (customField.type === ECustomFieldType.COST ||
            customField.type === ECustomFieldType.NUMBERS ||
            customField.type === ECustomFieldType.PERCENTAGE ||
            customField.type === ECustomFieldType.FORMULA)
        );
      })
      .map((customField: TCustomField) => ({
        type: EFormulaPieceType.CUSTOM_FIELD,
        value: customField.id.toString(),
      }))
      .sort((a, b) => {
        const firstCF = customFields[a.value];
        const secondCF = customFields[b.value];

        return firstCF.label.localeCompare(secondCF.label);
      });
  }

  addCustomField(customField: TFormulaPiece): void {
    this.ppSelectOperator.emit(customField);
  }

  private checkFormulaCustomFieldsDisabled(): void {
    this.disabled =
      this.ppFormula.filter((piece) => piece.type === EFormulaPieceType.CUSTOM_FIELD).length >=
      FORMULA_MAX_CUSTOM_FIELDS;
  }
}
